<template>
  <div class="main-home">
    <AppHead />
    <HomeLeadPopup />
    <MainBanner />
    <div class="banner-spacer" aria-hidden="true" />
    <TrustBand />

    <section class="hero-section position-relative overflow-hidden">
      <div class="hero-background"></div>
      <div class="container position-relative z-3">
        <div class="row align-items-center py-5 py-lg-6 g-4">
          <div class="col-12 col-lg-7 col-xl-6">
            <div class="hero-content">
              <h2 class="hero-title">
                Combien vaut réellement votre patrimoine aujourd’hui&nbsp;?
                <span class="gradient-text"> La plupart l’ignorent.</span>
              </h2>
              <p class="hero-lead">
                Actifs dispersés, tableurs, comptes séparés : sans vision consolidée, vous décidez à l’aveugle.
                Patrimonea consolide, structure et accompagne : outil digital &amp; conseiller dédié.
              </p>
              <div class="hero-actions">
                <router-link
                  to="/approche"
                  class="btn-brand btn-brand--primary"
                  @click="trackCta('home_mid', 'Découvrir notre approche')"
                >
                  Découvrir notre approche
                </router-link>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-5 col-xl-6 hero-visual-col">
            <div class="hero-visual">
              <img
                :src="accueilImg"
                class="hero-visual__img"
                alt="Aperçu de consolidation patrimoniale"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="process-section py-6 py-lg-8">
      <div class="container">
        <div class="section-header text-center mb-6">
          <div class="section-label text-uppercase letter-spacing-2 mb-3">À qui s’adresse-t-elle ?</div>
          <h2 class="process-heading">
            Patrimonea <span class="process-heading__accent">by Gwem</span> s’adresse aux&nbsp;:
          </h2>
          <span class="rule-brown rule-brown--center" aria-hidden="true" />
        </div>

        <div class="process-grid">
          <div class="process-card">
            <div class="process-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4 8h16v10H4z" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9 8V6a3 3 0 0 1 6 0v2" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="process-title">Cadres et cadres dirigeants</div>
          </div>
          <div class="process-card">
            <div class="process-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4 20v-8l8-4 8 4v8" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9 20v-6h6v6" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div class="process-title">Dirigeants et entrepreneurs</div>
          </div>
          <div class="process-card">
            <div class="process-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7 20h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path d="M9 20V7a3 3 0 1 1 6 0v13" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5 11h14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </div>
            <div class="process-title">Professions libérales</div>
          </div>
        </div>

        <div class="process-summary">
          <p class="process-summary__item">
            <span class="process-summary__star" aria-hidden="true">✷</span>
            Avec un revenu mensuel minimum net de 750&nbsp;000&nbsp;FCFA, souhaitant optimiser la gestion de leur patrimoine global.
          </p>
          <p class="process-summary__item">
            Avec des situations patrimoniales simples ou complexes, et souhaitant structurer, développer et transmettre leur patrimoine dans un cadre de confiance.
          </p>
          <p class="process-summary__item">
            Commencez par un diagnostic patrimonial confidentiel. En quelques minutes, obtenez une première analyse claire de votre situation et identifiez vos priorités patrimoniales.
          </p>
          <div class="process-actions">
            <router-link
              to="/approche#offres"
              class="btn-brand btn-brand--primary"
              @click="trackCta('home_audience', 'Voir les offres')"
            >
              Voir les offres
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <StickyCtaBar location="home_sticky" />

    <footer>
      <SiteFooter />
    </footer>
  </div>
</template>

<script>
import AppHead from '@/components/public/AppHead.vue';
import SiteFooter from '@/components/public/Footer.vue';
import MainBanner from '@/components/public/MainBanner.vue';
import TrustBand from '@/components/public/TrustBand.vue';
import StickyCtaBar from '@/components/public/StickyCtaBar.vue';
import HomeLeadPopup from '@/components/public/HomeLeadPopup.vue';
import accueilImg from '@/assets/img/conseiller-client-africain.png';
import { trackCtaClick, trackViewHome } from '@/utils/analytics';

export default {
  name: 'MainHome',
  components: {
    AppHead,
    SiteFooter,
    MainBanner,
    TrustBand,
    StickyCtaBar,
    HomeLeadPopup,
  },
  data() {
    return { accueilImg };
  },
  mounted() {
    trackViewHome();
  },
  methods: {
    trackCta(location, label) {
      trackCtaClick({ location, label });
    },
  },
};
</script>

<style scoped>
.form-control-luxury-option {
  color: var(--bank-gray-900);
}

/* Styles généraux */
.main-home {
  font-family: var(--font-body);
  background: var(--paper);
  color: var(--brand-ink);
  overflow-x: clip;
}

.banner-spacer {
  height: clamp(28px, 4vw, 48px);
  background: var(--paper);
}

/* Fallback container padding (déploiement sans Bootstrap) */
.container {
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: clamp(16px, 4vw, 24px);
  padding-right: clamp(16px, 4vw, 24px);
}

/* Hero Section */
.hero-section {
  background:
    linear-gradient(
      90deg,
      rgba(1, 38, 62, 0.94) 0%,
      rgba(1, 38, 62, 0.78) 48%,
      rgba(1, 38, 62, 0.45) 100%
    ),
    url(@/assets/img/hero-famille-patrimoine.png);
  background-size: cover;
  background-position: center right;
  background-attachment: scroll;
  position: relative;
  overflow: hidden;
  min-height: min(640px, 85vh);
  display: flex;
  align-items: center;
  isolation: isolate;
  margin-top: clamp(12px, 2vw, 24px);
  margin-bottom: clamp(12px, 2vw, 24px);
}

.hero-visual {
  position: relative;
  width: min(520px, 100%);
  margin-left: auto;
  padding: 16px;
  border-radius: 28px;
  box-shadow: 0 18px 55px rgba(2, 6, 23, 0.42);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.hero-visual__img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 18px;
  object-fit: cover;
}

.process-summary {
  max-width: 46rem;
  margin: 0 auto;
  text-align: left;
  font-family: var(--font-body);
  font-size: 1rem;
  line-height: 1.65;
  background: transparent;
  color: var(--brand-navy);
  border-radius: 0;
  padding: 0.5rem 0 0;
}

.process-summary__item {
  margin: 0 0 0.9rem;
  font-family: var(--font-body);
  font-size: 0.98rem;
  line-height: 1.6;
  color: var(--brand-navy);
}

.process-summary__item:last-of-type {
  margin-bottom: 0;
}

.process-summary__star {
  color: var(--brand-gold);
  margin-right: 0.35rem;
}

.hero-visual-col {
  display: flex;
  justify-content: center;
}

@media (min-width: 992px) {
  .hero-visual-col {
    justify-content: flex-end;
  }
}

/* Mobile / tablette : carte aperçu centrée,
cadre doré,
relief doux */
@media (max-width: 991.98px) {
  .hero-visual {
    width: min(420px, 100%);
    margin-right: auto;
    padding: 12px 12px 14px;
    border-radius: 22px;
    border: 1px solid color-mix(in srgb, var(--bank-gold) 42%, transparent);
    background: color-mix(in srgb, var(--bank-white) 10%, transparent);
    box-shadow:
      0 20px 50px rgba(0, 0, 0, 0.35),
      0 0 0 1px color-mix(in srgb, var(--bank-gold) 18%, transparent),
      inset 0 1px 0 color-mix(in srgb, var(--bank-white) 14%, transparent);
  }

  .hero-visual__img {
    border-radius: 14px;
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);
  }
}

/* Perf mobile: éviter le jank lié au background fixed */
@media (max-width: 1024px) {
  .hero-section {
    background-attachment: scroll;
  }
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 80% 20%, color-mix(in srgb, var(--bank-gold) 10%, transparent) 0%, transparent 50%),
    radial-gradient(circle at 20% 80%, color-mix(in srgb, var(--bank-secondary) 14%, transparent) 0%, transparent 50%);
}

.hero-title {
  margin: 0 0 1.1rem;
  font-family: var(--font-display);
  font-size: clamp(1.75rem, 1.35rem + 1.5vw, 2.5rem);
  line-height: 1.2;
  letter-spacing: -0.02em;
  font-weight: 600;
  color: var(--paper, #fff) !important;
  text-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}

.hero-lead {
  margin: 0 0 1.9rem;
  font-family: var(--font-body);
  font-size: clamp(1rem, 0.95rem + 0.35vw, 1.125rem);
  font-weight: 400;
  line-height: 1.65;
  color: color-mix(in srgb, var(--bank-white) 92%, transparent);
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.45);
  max-width: 44rem;
}
@media (min-width: 1200px) {
  .fs-3 {
    font-size: 1.25rem !important;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: clamp(1.85rem, 1.35rem + 2.2vw, 2.4rem);
  }

  .hero-lead {
    margin-bottom: 1.5rem;
  }
}

.gradient-text {
  color: var(--brand-gold);
  background: none;
  -webkit-text-fill-color: var(--brand-gold);
  text-shadow: none;
}

.text-gold {
  color: var(--bank-gold) !important;
}

.process-summary p,
.process-summary__item {
  color: var(--brand-navy) !important;
}

.required-asterisk {
  color: var(--bank-gold);
  font-size: 1.5em;
  margin-left: 2px;
}

.letter-spacing-1 { letter-spacing: 1px; }
.letter-spacing-2 { letter-spacing: 2px; }

.process-section {
  background: var(--paper, #fff);
  color: var(--brand-navy);
}

.process-section .section-label {
  font-family: var(--font-body);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  color: var(--brand-brown);
}

.process-heading {
  font-family: var(--font-display);
  font-size: clamp(1.75rem, 1.35rem + 1.5vw, 2.5rem);
  font-weight: 600;
  line-height: 1.2;
  color: var(--brand-navy);
  margin: 0 0 0.75rem;
}

.process-heading__accent {
  color: var(--brand-brown);
  font-weight: 700;
}

.rule-brown--center {
  margin-left: auto;
  margin-right: auto;
}

.process-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.process-card {
  background: var(--paper);
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  box-shadow: var(--shadow-sm);
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.process-card:hover {
  transform: translateY(-4px);
  border-color: color-mix(in srgb, var(--brand-gold) 55%, var(--line));
  box-shadow: var(--shadow-md);
}

.process-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--brand-gold-soft);
  color: var(--brand-gold-dark);
  border: 1px solid color-mix(in srgb, var(--brand-red) 22%, transparent);
  flex-shrink: 0;
}

.process-icon svg {
  width: 28px;
  height: 28px;
}

.process-title {
  font-family: var(--font-body);
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--brand-navy);
  line-height: 1.35;
}

.process-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;
  margin-top: 1.5rem;
}

.process-actions .btn-brand--primary {
  text-transform: none;
  letter-spacing: 0.02em;
}

.process-link {
  font-family: var(--font-body);
  font-size: 0.92rem;
  color: var(--brand-brown);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.process-link:hover {
  color: var(--brand-red);
}

/* Responsive */
@media (max-width: 768px) {
  .hero-actions {
    flex-direction: column;
  }
  
  .hero-actions .btn {
    width: 100%;
    justify-content: center;
  }
  
  .process-grid {
    grid-template-columns: 1fr;
  }
  
  .process-card {
    padding: 1.25rem;
  }
  
  .btn-outline-light{
    margin-bottom: 70px;
  }
}

/* Contact items */
.contact-icon {
  width: 40px;
  height: 40px;
  background: rgba(212, 175, 55, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Value in card */
.value {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--bank-gold);
  text-shadow: 0 2px 8px rgba(10,26,47,0.18);
}

/* Section spacing */
.py-6 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.py-lg-8 {
  padding-top: 7rem;
  padding-bottom: 7rem;
}

@media (max-width: 768px) {
  .py-6 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  
  .py-lg-8 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
}

.section-divider-prestige {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, var(--bank-gold), var(--bank-primary));
  margin: 1rem auto 0;
  border-radius: 2px;
  opacity: 0.7;
}

/* Lisibilité : limiter la largeur du texte long du hero */
.hero-content {
  max-width: 46rem;
  padding-top: clamp(1.5rem, 3vw, 2.75rem);
  padding-bottom: clamp(1.5rem, 3vw, 2.75rem);
}

.cta-micro {
  margin: 0;
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.72);
}

.cta-micro--on-dark {
  color: rgba(255, 255, 255, 0.72);
}

.cta-link-secondary {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.92rem;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.cta-link-secondary--on-dark {
  color: rgba(255, 255, 255, 0.88);
}

.hero-actions .btn-brand--primary {
  text-transform: none;
  letter-spacing: 0.02em;
  height: auto;
  min-height: 48px;
  padding: 0.75rem 1.25rem;
  white-space: normal;
}

.hero-section {
  min-height: auto;
}

</style>
